import { render, staticRenderFns } from "./BindWeixinSuccess.vue?vue&type=template&id=7661838d"
import script from "./BindWeixinSuccess.vue?vue&type=script&lang=ts"
export * from "./BindWeixinSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports